import React from "react";

import { EM_DASH, formatDate } from "../../../lib/utils";

type FormattedDateProps = {
  date: string | null | undefined;
  locale?: string;
  format?: string;
  className?: string;
  placeholder?: string;
};

export const FormattedDate = ({
  date,
  locale = "en-GB",
  format = "dd LLL, yyyy",
  className,
  placeholder = EM_DASH,
}: FormattedDateProps) => {
  if (!date || isNaN(new Date(date).getTime())) return <>{placeholder}</>;

  const parsedDate = new Date(date);

  return <span className={className}>{formatDate(parsedDate, locale, format)}</span>;
};
